var map = {
	"./banner.jpg": "0f2b",
	"./brands/austrogiros.png": "a20a",
	"./brands/facilito.png": "fb8e",
	"./brands/western-union.png": "fc6e",
	"./covenants/banner.jpg": "7230",
	"./iconoBASICOS.png": "56df",
	"./iconoCATALOGOS.png": "f5a6",
	"./iconoDEPOSITOS.png": "2605",
	"./iconoESTATALES.png": "141d",
	"./iconoPRINCIPAL.png": "9268",
	"./iconoTARJETA.png": "a5e9",
	"./iconoTELEFONICA.png": "5dbb",
	"./iconoUNIVERSIDAD.png": "c692",
	"./logos/logo1.png": "9d5a",
	"./logos/logo2.png": "2ace"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "792c";